<template>
    <v-card @click="Open"
            elevation="4"
            color="blue darken-3"
            dark
            class="text-sm-center"
            style="cursor:pointer;">
        <v-card-title>
            <h2 class="mx-auto my-0">Societies</h2>
        </v-card-title>
        <v-card-title>
            <v-icon large class="mx-auto my-0">fas fa-share-alt</v-icon>
        </v-card-title>
        <v-card-text>
            <div class="text-center">There is a range of societies and clubs to enhance College life</div>
        </v-card-text>
        <v-card-actions>
            <v-btn dark text block>Learn About Our Societies</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import ctrlOpenMixin from '@/views/components/mixins/base/ctrlOpen.js'

    export default {
        mixins: [ctrlOpenMixin],
        methods: {
            Open() { this.CtrlOpen('/societies'); }
        },
    }
</script>
